import { ReportHistory } from '../models/report-history.model';
import { ReportSchedule } from '../models/report-schedule.model';
import { SaveCustomReportData } from '../models/custom-report.model';

export class GetCustomReports {
	static readonly type = '[Report] GetCustomReports';
}

export class GetCustomReport {
	static readonly type = '[Report] GetCustomReport';
	constructor(public id: number) {}
}

export class GetCustomReportTables {
	static readonly type = '[Report] GetCustomReportTables';
}

export class DeleteCustomReport {
	static readonly type = '[Report] DeleteCustomReport';
	constructor(public id: number) {}
}

export class SaveCustomReport {
	static readonly type = '[Report] SaveCustomReport';
	constructor(public saveData: SaveCustomReportData) {}
}

export class GetPreCannedReports {
	static readonly type = '[Report] GetPreCannedReports';
}

export class GetAllReports {
	static readonly type = '[Report] GetAllReports';
}

export class ClearReportHTML {
	static readonly type = '[Report] ClearReportHTML';
}

export class GetReportHTML {
	static readonly type = '[Report] GetReportHTML';
	constructor(public id: number) {}
}

export class DownloadReport {
	static readonly type = '[Report] DownloadReport';
	constructor(
		public id: number,
		public name: string,
		public type: string
	) {}
}

export class GetReportSchedules {
	static readonly type = '[Report] GetReportSchedules';
}

export class GetReportSchedule {
	static readonly type = '[Report] GetReportSchedule';
	constructor(public id: number) {}
}

export class SaveReportSchedule {
	static readonly type = '[Report] SaveReportSchedule';
	constructor(public schedule: ReportSchedule) {}
}

export class DeleteReportSchedule {
	static readonly type = '[Report] DeleteReportSchedule';
	constructor(public id: number) {}
}

export class GetReportHistory {
	static readonly type = '[Report] GetReportHistory';
}

export class DownloadScheduledReports {
	static readonly type = '[Report] DownloadScheduledReports';
	constructor(public report: ReportHistory) {}
}
